import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import _isUndefined from 'lodash/isUndefined';
import _map from 'lodash/map';
import _isEmpty from 'lodash/isEmpty';
import _get from 'lodash/get';

// Components
import Heading from '../Heading';
import Subheading from '../Subheading';
import ToggleArrow from '../ToggleArrow';
import Collapse from '../Collapse';

// Icons
import RoadIcon from '../../icons/map/road.svg';
import CloseIcon from '../../icons/close.svg';
import placemarktIcon from './assets/pizzeria-pin.svg';

// Utils
import { plainPhoneNumber } from '../../utils/telephone';

// Styles
import styles from './ContactsMap.styl';

const cx = classNames.bind(styles);

export default class MapInfoWindow extends Component {
  state = {
    windowIsOpen: false,
    windowWasClosed: false,
    fullsizeIsOpen: false,
    contentIsOpen: false,
    onAnimationStart: false,
    currentPolygonId: this.props.selectedPolygonId,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedPolygonId !== this.props.selectedPolygonId) {
      this.setState({ currentPolygonId: this.props.selectedPolygonId, windowWasClosed: false });

      if (!nextProps.selectedPolygonId) {
        setTimeout(() => {
          this.setState({ fullsizeIsOpen: false });
        }, 300);
      }
    }
  }

  toggleContent = () => this.setState({ contentIsOpen: !this.state.contentIsOpen });

  toggleWindowOpen = () => this.setState({ fullsizeIsOpen: !this.state.fullsizeIsOpen });

  onAnimationStart = () => {
    this.setState({ onAnimationStart: !this.state.onAnimationStart });
  };

  onWindowOpen = () => {
    this.setState({ windowIsOpen: !this.state.windowIsOpen });
  };

  onCloseWindowInfo = () => {
    this.setState({
      windowWasClosed: true,
    });
  };

  render() {
    const { isPhone, selectedPolygonId, isButtonRoute, currentRestarant } = this.props;
    const { contentIsOpen, fullsizeIsOpen, onAnimationStart, windowWasClosed } = this.state;

    return !_isEmpty(currentRestarant) && !windowWasClosed ? (
      <Collapse
        className={cx('InfoWindow', {
          InfoWindow_isOpen: fullsizeIsOpen,
          InfoWindow_isAnimated: onAnimationStart,
        })}
        contentClassName={cx('InfoWindow__container')}
        isOpen={!_isUndefined(selectedPolygonId)}
        onAnimationStart={this.onAnimationStart}
        onAnimationEnd={this.onWindowOpen}
      >
        <>
          {isPhone && (
            <div className={cx('InfoWindow__actions')}>
              <div className={cx('InfoWindow__toggleButton')} onClick={this.toggleWindowOpen} />
            </div>
          )}
          <div className={cx('InfoWindow__inner')}>
            <div className={cx('InfoWindow__header')}>
              <div className={cx('InfoWindow__close')} onClick={this.onCloseWindowInfo}>
                <CloseIcon width={16} height={16} />
              </div>
              <div className={cx('InfoWindow__title')}>
                <FormattedMessage id="map.infoWindow.title" />
              </div>
            </div>
            <div className={cx('InfoWindow__content')}>
              {currentRestarant.address && (
                <div className={cx('InfoWindow__contentItem')}>
                  <img className={cx('InfoWindow__contentIcon')} src={placemarktIcon} />
                  <Heading level={4} tagName="div" className={cx('InfoWindow__label')}>
                    {currentRestarant.address}
                  </Heading>
                  {currentRestarant.metro && (
                    <div>
                      {currentRestarant.metro.split(';').map((item, key) => (
                        <Subheading key={key}>
                          <FormattedMessage id="map.infoWindow.metro" /> &laquo;{item.trim()}&raquo;
                        </Subheading>
                      ))}
                    </div>
                  )}
                </div>
              )}
              <div className={cx('InfoWindow__contentItem')}>
                {currentRestarant.phone_api && (
                  <Heading
                    level={4}
                    tagName="a"
                    href={`tel:${plainPhoneNumber(currentRestarant.phone_api)}`}
                    className={cx('InfoWindow__label', 'InfoWindow__label_link')}
                  >
                    {currentRestarant.phone_api}
                  </Heading>
                )}
                {currentRestarant.open && (
                  <div className={cx('InfoWindow__worktime')}>
                    {_map(currentRestarant.open, (item, key) => (
                      <div className={cx('InfoWindow__worktimeRow')} key={key}>
                        <Subheading className={cx('InfoWindow__worktimeItem')}>{key}</Subheading>
                        <Subheading className={cx('InfoWindow__worktimeItem')}>{item}</Subheading>
                      </div>
                    ))}
                  </div>
                )}
              </div>
              {currentRestarant.delivery && (
                <div className={cx('InfoWindow__contentItem', 'InfoWindow__contentItem_toggle')}>
                  <Heading
                    level={4}
                    tagName="div"
                    className={cx('InfoWindow__label')}
                    onClick={this.toggleContent}
                  >
                    <FormattedMessage id="map.infoWindow.workTimeDelivery" />
                    <ToggleArrow className={cx('InfoWindow__toggleIcon')} isOpen={contentIsOpen} />
                  </Heading>
                  <Collapse isOpen={contentIsOpen}>
                    <div className={cx('InfoWindow__worktime')}>
                      {_map(_get(currentRestarant, 'delivery', {}), (item, key) => (
                        <div className={cx('InfoWindow__worktimeRow')} key={key}>
                          <Subheading className={cx('InfoWindow__worktimeItem')}>{key}</Subheading>
                          <Subheading className={cx('InfoWindow__worktimeItem')}>{item}</Subheading>
                        </div>
                      ))}
                    </div>
                  </Collapse>
                </div>
              )}
              {currentRestarant.characteristics && (
                <div className={cx('InfoWindow__contentItem')}>
                  <div className={cx('InfoWindow__characteristics')}>
                    {_map(currentRestarant.characteristics, (item, id) => (
                      <div
                        key={id}
                        className={cx('InfoWindow__characteristicsItem')}
                        title={item.name}
                      >
                        <img src={item.icon} alt="" />
                        <div className={cx('InfoWindow__label')}>{item.value}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div className={cx('InfoWindow__footer')}>
              <div className={cx('InfoWindow__footerGradient')} />
              <div className={cx('InfoWindow__footerInner')}>
                {isButtonRoute && (
                  <button className={cx('InfoWindow__buttonRoute')}>
                    <RoadIcon width={24} height={24} onClick={this.props.switchRouteWindow} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </>
      </Collapse>
    ) : null;
  }
}

MapInfoWindow.defaultProps = {
  selectedPolygonId: undefined,
  currentRestarant: {},
};

MapInfoWindow.propTypes = {
  isPhone: PropTypes.bool,
  selectedPolygonId: PropTypes.any,
  currentRestarant: PropTypes.object,
  switchRouteWindow: PropTypes.func,
  isButtonRoute: PropTypes.bool,
};
